import { render, staticRenderFns } from "./TestAPITabs.vue?vue&type=template&id=33a9bb7e&scoped=true"
import script from "./TestAPITabs.vue?vue&type=script&lang=js"
export * from "./TestAPITabs.vue?vue&type=script&lang=js"
import style0 from "./TestAPITabs.vue?vue&type=style&index=0&id=33a9bb7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a9bb7e",
  null
  
)

export default component.exports